module.exports = __webpack_public_path__ + "img/colink.40f2b764.png";